module.exports = __webpack_public_path__ + "img/Murugo.1576b75b.png";